import React, { Component } from "react";
import CarouselWidget from "./CarouselWidget";



export default class CaseOfTheMonth extends Component {

  constructor(props){
    super(props);
    this.state ={
      images: []
    };
  }

  render() {

      return(
        <div className="card retnet-com">
              <div className="card-header retnet-com-header">
                  Case Of The Month
              </div>
              <div className="card-body retnet-com-carousel">
                  <CarouselWidget  blog={this.props.blog} blogimages={this.props.blogimages}/>
              </div>
              <div className="retnet-com-title">
                  {this.props.blog.title}
              </div>
          </div>

      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CaseOfTheMonth.js